<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
      language: 'setting/getLanguage',
      shouldUpdate: 'menu/getShouldUpdate',
    }),
  },
  watch: {
    shopId(shopId) {
      // TODO:認証エラー対応。日本版だと事前注文に影響する可能性があるので、台湾版のみ
      if (shopId !== null && this.seatNo !== null) {
        this.fetchMenu()
      }
    },
    language() {
      if (this.shopId) {
        this.fetchMenu(true)
      }
    },
    async shouldUpdate(bool) {
      if (bool) {
        this.setShouldUpdate(false)
        await this.fetchMenu()
      }
    },
  },
  methods: {
    ...mapActions({
      fetchMenu: 'menu/fetchMenu',
      setShouldUpdate: 'menu/setShouldUpdate',
    }),
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
